import buttonLoader from '@/components/button';

import Api from '@/utils/api';

import { REGEX } from '@/utils/const';

export default {
  components: {
    buttonLoader,
  },
  data () {
    return {
      emailRegex: REGEX.emailRegex,
      email: '',
      message: '',
      loadingButton: false,
      typeResponse: '',
      load: false,
    };
  },
  mounted () {
    this.load = true;
  },
  methods: {

    /**
         * Method for reset password
         */
    resetPassword () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.loadingButton = true;

            Api.auth
              .restorePassword({ email: this.email })
              .then((data) => {
                if (data.data.Status) {
                  this.message = data.data.Message;
                  this.loadingButton = false;
                  this.error = false;
                  this.typeResponse = 'success';
                } else {
                  this.message = data.data.Message;
                  this.loadingButton = false;
                  this.typeResponse = 'fail';
                }
              });
          } else {
            this.loadingButton = false;
          }
        });
    },

  },
};
